<template>
  <div>
    <div v-if="item.birthdayNotification === false">
      <div class="notification-item">
        <div class="notification-item-icon">
          <svg-icon v-if="item.announcementNotification === false" icon="analytics" />
          <svg-icon v-if="item.announcementNotification === true" icon="megaphone" />
        </div>
        <div class="notification-item-section">
          <strong>{{ notificationTitle }}</strong>
        </div>
      </div>
      <div class="notif-content">
        <div class="notif-content-icon"></div>
        <div class="notif-content-section">
          <article v-html="notificationBody" />
          <p class="notif-content-minute">{{ item.notificationDate }}</p>
          <div class="mb-4">
            <v-btn
              color="primary btn-primary-custom"
              small
              v-if="item.analyticalQuitionnaireId"
              :disabled="item.quitionnaireFilled"
              @click="takeQuiz(item.analyticalQuitionnaireId)"
              >Take Questionnaire
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <div v-if="item.birthdayNotification === true">
      <div class="notification-item">
        <div class="notification-item-icon">
          <svg-icon icon="ic_cake" class="primary--text" />
        </div>
        <div class="notification-item-section">
          <strong>Happy Birthday</strong>
        </div>
      </div>
      <div class="notif-content">
        <div class="notif-content-icon"></div>
        <div class="notif-content-section mb-3">
          <div class="succ pa-3 d-flex d-inline">
            <svg-icon icon="cake" width="100" height="100" />
            <strong class="text-birthday pa-4">{{ $i18n.locale === 'en' ? item.notificationBodyEn : item.notificationBodyIdn }}</strong>
            <v-btn color="primary btn-primary-custom btn-birthday mt-2" @click="birthdayGo(item.notificationId)">See Happy Birthday </v-btn>
          </div>
          <p class="notif-content-minute">{{ item.notificationDate }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      localItem: { ...this.item } // shallow copy
    };
  },
  methods: {
    birthdayGo(item) {
      this.$router.push({ name: 'personalBirthday', params: { id: item } });
    },
    takeQuiz(item) {
      this.$router.push({ name: 'teacherQuiz', params: { id: item } });
    }
  },
  computed: {
    notificationTitle() {
      return this.$i18n.locale === 'en' ? this.localItem.notificationTitleEn : this.localItem.notificationTitleIdn;
    },
    notificationBody: {
      get() {
        return this.$i18n.locale === 'en' ? this.localItem.notificationBodyEn : this.localItem.notificationBodyIdn;
      },
      set(value) {
        if (this.$i18n.locale === 'en') {
          this.$set(this.localItem, 'notificationBodyEn', value);
        } else {
          this.$set(this.localItem, 'notificationBodyIdn', value);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.notification-item {
  display: flex;
  flex-direction: column;
  padding: 10px 0;

  &:last-child {
    border-bottom: 0;
  }

  &-icon {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background: #fff0da;
    text-align: center;
    line-height: 24px;
    margin-right: 12px;

    svg {
      fill: #f1b65a;
      margin-top: 3px;
    }
  }

  &-section {
    margin-bottom: 15px;

    &:last-child {
      margin-bottom: 0;
    }

    &-title {
      display: block;
    }

    strong {
      color: #6d6d6d;
    }
  }

  @include query-min-sm() {
    flex-direction: row;
    align-items: center;

    &-section {
      flex-basis: 25%;
      margin-bottom: 0;
    }
  }
}
.notif-content {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #acacac;

  &-icon {
    width: 24px;
    height: 24px;
    margin-right: 12px;
  }
  &-minute {
    padding-top: 10px;
    color: #ce8800;
  }

  @include query-min-sm() {
    flex-direction: row;
    align-items: center;

    &-section {
      flex-basis: 100%;
      margin-bottom: 0;
    }
  }
}

.succ {
  background-color: #eef6fc;
  border-radius: 8px;
  height: 84px;
}
.text-birthday {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
}
</style>
